exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#mainChannelClient[data-v-2eb02bd9] {\n  padding-top: 15px;\n}\n.ag-theme-material[data-v-2eb02bd9] .ag-root-wrapper {\n  overflow: visible !important;\n}\n", ""]);

// exports
